import ProductContainerInfinity from './ProductContainerInfinity.jsx';

export default ProductContainerInfinity;


// WEBPACK FOOTER //
// ./src/components/ProductContainerInfinity/index.jsx